/** @format — Shared filter dropdown panel */

import { cn } from "@/lib/utils";

export default function FilterMenuPanel({
  children,
  className,
  width,
}: {
  children: React.ReactNode;
  className?: string;
  width?: number | string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-0.5 rounded-lg border border-neutral-200 bg-white p-0.5 shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.1)]",
        className,
      )}
      style={width ? { width } : undefined}
    >
      {children}
    </div>
  );
}
